import React, { Component } from "react";
import getKMReport from "../../services/kmreporting";
import _ from "lodash";
import moment from "moment";
import DatePicker from "react-datepicker";
import {
  Card,
  CardHeader,
  Table,
  Container,
  Row,
  Col,
  Spinner,
} from "reactstrap";

class KMReport extends Component {
  state = {
    products: [],
    sdt: moment().subtract(30, "days").format("YYYY-MM-DD"),
    edt: moment().format("YYYY-MM-DD"),
    vehicleIds: [],
    isLoading: true,
  };

  fromToDate = [];

  componentDidMount() {
    this.callDashboardData();
  }

  async callDashboardData() {
    this.fromToDate = [];
    const products = await getKMReport(this.state.sdt, this.state.edt);
    var vehicleIds = _.uniqBy(products, "vdevice");
    //creating JS date objects
    var start = new Date(this.state.sdt);
    var end = new Date(this.state.edt);

    //Logic for getting rest of the dates between two dates("FromDate" to "EndDate")
    while (start < end) {
      this.fromToDate.push(moment(start).format("YYYY/MM/DD"));
      var newDate = start.setDate(start.getDate() + 1);
      start = new Date(newDate);
    }
    this.setState({ products, vehicleIds, isLoading: false });
  }

  getFilteredData(vehicleId) {
    return _.filter(this.state.products, { vdevice: vehicleId });
  }

  callme(temp, date) {
    var fetchedDate = temp.filter(
      (tempObject) =>
        moment(new Date(tempObject.vdate)).format("YYYY/MM/DD") === date
    );
    return fetchedDate[0]?.mileagekm === undefined
      ? 0
      : parseFloat(fetchedDate[0].mileagekm).toFixed(2);
  }

  async updateStartDate(date)  {
   await this.setState({ sdt: moment(date).format("YYYY-MM-DD"), isLoading: true });
   await this.callDashboardData();
  }

  async updateEndDate(date) {
    await this.setState({ edt: moment(date).format("YYYY-MM-DD"), isLoading: true });
    await this.callDashboardData();
  }

  render() {
    return (
      <Container className="pt-8 pb-4 header bg-gradient-info" fluid>
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0">
                <Row style={{ alignItems: "center" }}>
                  <Col>
                    <h3 className="mb-0">KM Detailed Report</h3>
                  </Col>
                  <Col>
                    <Row>
                      {" "}
                      <h3 className="pr-1"> Start Date: </h3>{" "}
                      <DatePicker
                        className="input-group"
                        selected={new Date(this.state.sdt)}
                        onChange={(date) => this.updateStartDate(date)}
                      />
                    </Row>
                  </Col>
                  <Col>
                    <Row>
                      {" "}
                      <h3 className="pr-1">End Date:</h3>{" "}
                      <DatePicker
                        className="input-group"
                        selected={new Date(this.state.edt)}
                        onChange={(date) => this.updateEndDate(date)}
                      />
                    </Row>
                  </Col>
                </Row>
              </CardHeader>

              {this.state.isLoading ? (
                <Row className="p-9">
                  <Col style={{ textAlign: "center" }}>
                    <Spinner color="success" />
                  </Col>
                </Row>
              ) : (
                <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                    <tr>
                      <th scope="col">Vehicle No</th>
                      {this.fromToDate.map((e, key) => (
                        <th scope="col" key={key}>
                          {e}
                        </th>
                      ))}
                      ;
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.vehicleIds.map((ele, key) => {
                      var temp = this.getFilteredData(ele.vdevice);
                      //console.log(temp);
                      return (
                        <tr key={key}>
                          <td>{ele.vdevice}</td>
                          {this.fromToDate.map((date, keyId) => (
                            <td keyId={keyId}> {this.callme(temp, date)}</td>
                          ))}
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              )}
            </Card>
          </div>
        </Row>
      </Container>
    );
  }
}

export default KMReport;
